package org.catharsis.spendtel.feature.presentation.web

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.foundation.ScrollState
import org.catharsis.spendtel.feature.presentation.expensereport.SpendTelReportColors
import org.catharsis.spendtel.ui.components.PlatformScrollableColumn

@Composable
fun WebViewportScrollColumn(
    scrollState: ScrollState,
    modifier: Modifier = Modifier,
    maxContentWidth: Dp = webPageMaxWidth,
    content: @Composable ColumnScope.() -> Unit,
) {
    PlatformScrollableColumn(
        modifier = modifier.fillMaxSize(),
        scrollState = scrollState,
    ) {
        Box(
            modifier = Modifier.fillMaxWidth(),
            contentAlignment = Alignment.TopCenter,
        ) {
            Column(
                modifier = Modifier
                    .widthIn(max = maxContentWidth)
                    .fillMaxWidth(),
                content = content,
            )
        }
    }
}

@Composable
fun WebAmbientPageBackground(modifier: Modifier = Modifier) {
    Box(modifier = modifier) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(
                    Brush.verticalGradient(
                        colors = listOf(
                            Color(0xFFF8FAFC),
                            Color(0xFFF6F4FB),
                            Color(0xFFF2FAF8),
                        ),
                    ),
                ),
        )

        Box(
            modifier = Modifier
                .size(520.dp)
                .align(Alignment.TopEnd)
                .offset(x = 160.dp, y = (-140).dp)
                .clip(CircleShape)
                .background(SpendTelReportColors.violet.copy(alpha = 0.08f)),
        )

        Box(
            modifier = Modifier
                .size(380.dp)
                .align(Alignment.CenterStart)
                .offset(x = (-200).dp, y = 60.dp)
                .clip(CircleShape)
                .background(SpendTelReportColors.mint.copy(alpha = 0.07f)),
        )

        Box(
            modifier = Modifier
                .size(300.dp)
                .align(Alignment.BottomEnd)
                .offset(x = 80.dp, y = 120.dp)
                .clip(CircleShape)
                .background(SpendTelReportColors.amber.copy(alpha = 0.06f)),
        )

        Box(
            modifier = Modifier
                .size(220.dp)
                .align(Alignment.TopStart)
                .offset(x = (-60).dp, y = 180.dp)
                .clip(CircleShape)
                .background(SpendTelReportColors.teal.copy(alpha = 0.05f)),
        )
    }
}
